<template>
    <v-container fluid>
        <v-data-table
            :headers="headers"
            :items="itemsFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
            :height="$vuetify.breakpoint.mdAndDown ? '75vh' : '66vh'"
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h1 class="mr-4">LOUVERS</h1>
                        <v-btn
                            rounded
                            color="primary"
                            @click="openCreateItem"
                            class="mx-2"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                            {{ $vuetify.breakpoint.smAndDown ? '' : 'NEW' }}
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.name`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByName"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.price`]="{ item }">
                <p class="py-0 my-0">{{ formatNumber(item.price) }}</p>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openEditItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn small icon @click="openDeleteItem(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <!--FORM-->
        <v-dialog
            v-model="openItemForm"
            :retain-focus="false"
            persistent
            width="600px"
        >
            <FinishForm
                v-if="openItemForm"
                :createForm="createForm"
                :item="selectedItem"
                :originalItem="originalItem"
                :setting="setting"
                @addItem="addItem"
                @replaceItem="replaceItem"
                @close="closeEditItem"
            />
        </v-dialog>
        <!--Delete-->
        <v-dialog
            v-model="openDeleteWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="openDeleteWarning">
                <v-card-title class="text-h5">Delete Item</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this finish?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeDeleteItem">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deleteItem"
                        text
                        color="error"
                        :loading="loading"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import API from '@/services/api'

export default {
    name: 'Finish',
    props: {
        setting: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        FinishForm: () =>
            import('@/components/Settings/Clients/FinishForm.vue'),
    },
    data: () => ({
        loading: false,
        items: [],
        selectedItem: {},
        originalItem: {},
        createForm: true,
        openItemForm: false,
        openDeleteWarning: false,
        headers: [
            {
                text: 'NAME',
                value: 'name',
                sortable: false,
            },
            {
                text: 'PAINT COST (USD/KG)',
                value: 'paintCost',
                sortable: false,
            },
            {
                text: 'TOTAL ALUMINUM + PAINT (USD/KG)',
                value: 'totalUSD_KG',
                sortable: false,
            },
            {
                text: 'TOTAL ALUMINUM + PAINT (USD/LB)',
                value: 'totalUSD_LB',
                sortable: false,
            },
            {
                text: 'PAINT COST 1 SIDES (USD/M2)',
                value: 'paintCost1Sides',
                sortable: false,
            },
            {
                text: 'PAINT COST 2 SIDES (USD/M2)',
                value: 'paintCost2Sides',
                sortable: false,
            },
            {
                text: 'LEAD TIME (WEEKS)',
                value: 'leadTime',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
                align: 'center',
            },
        ],
        searchByName: undefined,
    }),
    async mounted() {
        try {
            this.loading = true
            this.items = await API.getAllFinish(this.setting.id)
        } catch (error) {
            this.setErrorItems({
                name: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    computed: {
        itemsFiltered() {
            const conditions = []
            if (this.searchByName) {
                conditions.push(this.filterByName)
            }
            if (conditions.length > 0) {
                return this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            this.sort()
            return this.items
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        sort() {
            this.items.sort((a, b) => a.name.localeCompare(b.name))
        },
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE', {
                maximumFractionDigits: 4,
            }).format(number || 0)
        },
        filterByName(item) {
            return item.name
                .toLowerCase()
                .includes(this.searchByName.toLowerCase())
        },
        replaceItem(itemToUpdate) {
            const index = this.items.findIndex(
                item => item.id == itemToUpdate.id
            )
            if (index >= 0) {
                this.items.splice(index, 1, {
                    ...this.items[index],
                    ...itemToUpdate,
                })
            }
        },
        addItem(item) {
            this.items.push(item)
            this.searchByName = ''
        },
        removeItem() {
            const index = this.items.findIndex(
                item => item.id == this.selectedItem.id
            )
            if (index >= 0) {
                this.items.splice(index, 1)
            }
        },
        async deleteItem() {
            try {
                this.loading = true
                await API.deleteFinish({
                    settingId: this.setting.id,
                    id: this.selectedItem.id,
                })
                this.removeItem()
                this.closeDeleteItem()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeDeleteItem() {
            this.selectedItem = {}
            this.openDeleteWarning = false
        },
        openDeleteItem(item) {
            this.selectedItem = _.cloneDeep(item)
            this.openDeleteWarning = true
        },
        closeEditItem() {
            this.createForm = true
            this.selectedItem = {}
            this.originalItem = {}
            this.openItemForm = false
        },
        openEditItem(item) {
            this.createForm = false
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
            this.openItemForm = true
        },
        openCreateItem() {
            this.createForm = true
            this.openItemForm = true
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
    position: sticky;
    z-index: 2;
}
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
</style>
